import type { TypePolicies } from '@apollo/client';

export const cacheTypePolicies: TypePolicies = {
  // A revision id repeats across orders in one transaction, so entries stay embedded, not normalized.
  SalesOrderRevision: { keyFields: false },
  // A job's Activity and its work order's both key a work order change by its revision, with different text.
  ActivityEntry: { keyFields: false },
  Query: {
    fields: {
      // The detail page and the Locations tab both read locationGroup(id:) but select different
      // fields, so the second write has to merge into the first rather than replace it.
      locationGroup: { keyArgs: ['id'], merge: true },
      // The ledger query writes only movements(...) into a lot the report already read, so it must merge.
      lotHistory: { keyArgs: ['partId', 'lotNumber', 'tagId'], merge: true },
    },
  },
  SalesOrder: {
    fields: {
      // Failure rows have no id of their own, and each read returns the order's full current list.
      leafLinkSyncFailure: { merge: false },
    },
  },
};
